import React from "react";
import { Button } from "..";
import { Link } from "react-router-dom";
import "./intro.css";

function Intro({ className, title, description, buttonText, image }) {
  let classes = ["intro-solution", className].join(" ");
  return (
    <div className={classes}>
      <div className="intro-parag">
        <h2>{title}</h2>
        <p>{description}</p>
        <Link to="/services" className="call-to-action">
          <Button className="btn" primary>
            {buttonText}
          </Button>
        </Link>
      </div>
      <div className={`intro-img ${image}`}></div>
    </div>
  );
}

export default Intro;
